import { FeedItemPreview } from "./FeedItemPreview";

export default FeedItemPreview;
